export default {
  listNaturalness: [],
  naturalness: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
